if(/^\/aboutus\//.test(location.pathname)){

  $(() => {
    window.load.init.done(()=>{

      $.when(
        window.load['loadhtml'],
        window.load['aboutus-staff']
      ).done(() => {

        if(location.hash) $(`[data-target="${location.hash}"]`).tab('show');

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
          $('a[data-toggle="tab"]').removeClass('active')
          $(`a[data-toggle="tab"][data-target="${e.target.dataset.target}"]`).addClass('active')
        })

      })

    })
  })
}